const { GENDER_TYPE } = require("../app");

window.leadManage = new Vue({
    el: "#addLead",
    components: {
        //        'multiselect': Multiselect,
    },

    data: {
        leadData: {},
        leadSourceList: [],
        leadAssignToList: [],
        errorMessage: "",
        headerMessage: "Add Lead",
        selectedGenderType: [],
        genderTypeListArr: GENDER_TYPE,
        selectedLeadSourceList: [],
        selectedLeadAssignToList: [],
        formType: "add",
        leadVerificationError: "",
        readOnlyEmail: false,
        country: {
            callingCode: "+91",
        },
        countryList: [],
    },
    mounted: function() {
        $(".multiselect__input").each(function() {
            var input = $(this);
            input
                .closest(".multiselect")
                .attr("id", input.attr("id") + "-multiselect");
        });
        $(".multiselect__single").each(function() {
            var input = $(this);
            var multiselectDiv = input.closest(".multiselect");
            multiselectDiv.attr(
                "id",
                multiselectDiv.data("id") + "-multiselect"
            );
        });
        this.getCountryList();
    },
    methods: {
        getCountryList() {
            this.$http.get("/country/list").then((response) => {
                this.countryList = response.body.result;
            });
        },
        onCountryCodeChange: function(value) {
            console.log(value);
        },
        validateLeadUser: function() {
            if (
                $.trim(
                    this.leadData.leadUserMobile +
                        "" +
                        this.leadData.leadUserEmail
                ) == ""
            ) {
                this.leadVerificationError = "";
                return false;
            }
            let queryParam = $.param({
                mobile: this.leadData.leadUserMobile,
                email: this.leadData.leadUserEmail,
                callingCode: this.country.callingCode,
            });
            this.$http
                .get("/user/details/bymobileemail?" + queryParam)
                .then((response) => {
                    if (response.body.hasError) {
                        //toastr["error"](response.body.message, "FAILED!");
                        if (
                            this.leadData.leadUserEmail &&
                            this.leadData.leadUserMobile
                        ) {
                            this.leadData.leadUserName = "";
                        } else if (this.leadData.leadUserMobile) {
                            this.leadData.leadUserEmail = "";
                            this.leadData.leadUserName = "";
                        } else if (this.leadData.leadUserEmail) {
                            this.leadData.leadUserMobile = "";
                            this.leadData.leadUserName = "";
                            this.leadData.callingCode = "";
                        }
                        this.leadVerificationError = response.body.message;
                        return false;
                    }
                    var result = response.body.result;
                    if (result.user) {
                        if (result.user.email) {
                            this.leadData.leadUserEmail = result.user.email;
                        }
                        if (result.user.mobile) {
                            this.leadData.leadUserMobile = result.user.mobile;
                            this.country.callingCode = result.user.callingCode;
                            this.leadData.callingCode = result.user.callingCode;
                        }
                        if (result.user.firstName) {
                            this.leadData.leadUserName = result.user.firstName;
                        }
                        if (result.user.gender !== null) {
                            var genderTypeArr = $.map(
                                this.genderTypeListArr,
                                function(value, index) {
                                    if (
                                        value.name.toLowerCase() ==
                                        result.user.gender.toLowerCase()
                                    ) {
                                        return value;
                                    }
                                }
                            );
                            this.selectedGenderType =
                                genderTypeArr.length == 0
                                    ? []
                                    : genderTypeArr[0];
                            this.leadData.gender =
                                leadManage.selectedGenderType.id;
                        }
                        this.leadVerificationError = "";
                    } else {
                        if (
                            this.leadData.leadUserEmail &&
                            this.leadData.leadUserMobile
                        ) {
                        } else if (this.leadData.leadUserMobile) {
                            this.leadData.leadUserEmail = "";
                        } else if (this.leadData.leadUserEmail) {
                            this.leadData.leadUserMobile = "";
                        }
                        this.leadVerificationError = "";
                    }
                });
        },
        selectGenderType: function(value, id) {
            this.leadData.gender = value.id;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        selectLeadSourceList: function(value, id) {
            this.leadData.leadSourceCode = value.code;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        selectLeadAssignToList: function(value, id) {
            this.leadData.assignTo = value.code;
            setTimeout(function() {
                validate.customValidateMultiSelect([id]);
            }, 100);
        },
        openLeadForm: function(resetFrm) {
            this.formType = resetFrm;
            $("form label.error").hide();
            if (this.formType == "add") {
                this.selectedLeadSourceList = [];
                this.selectedLeadAssignToList = [];
                this.selectedGenderType = [];
            }
            this.getLeadSources();
            this.getLeadAssignTos();
            $("#addLead").modal("show");
        },
        getLeadSources: function() {
            this.$http.get("/lead/source/list").then((response) => {
                leadManage.leadSourceList = response.data.result;
                if (this.formType == "update") {
                    var selectLeadSource = $.map(
                        leadManage.leadSourceList,
                        function(value, index) {
                            if (
                                value.code == leadManage.leadData.leadSourceCode
                            ) {
                                return value;
                            }
                        }
                    );
                    leadManage.selectedLeadSourceList =
                        selectLeadSource.length == 0 ? [] : selectLeadSource[0];
                }
                if (this.formType == "add") {
                    var selectLeadSource = $.map(
                        leadManage.leadSourceList,
                        function(value, index) {
                            if (value.name.toLowerCase() == "walk in") {
                                return value;
                            }
                        }
                    );
                    leadManage.leadData.leadSourceCode =
                        selectLeadSource[0].code;
                    leadManage.selectedLeadSourceList =
                        selectLeadSource.length == 0 ? [] : selectLeadSource[0];
                }
                var customValidateElements = $(
                    "#addLead div#leadSourceId-multiselect"
                ).map(function(i, element) {
                    if ($(element).data("optional") === undefined) {
                        return $(element)
                            .find("input")
                            .attr("id");
                    }
                });
                setTimeout(function() {
                    validate.customValidateMultiSelect(customValidateElements);
                }, 100);
            });
        },
        getLeadAssignTos: function() {
            this.$http.get("/staff/reportee/list").then((response) => {
                this.leadAssignToList = response.data.result;
            });
            //            if (this.formType == "update") {
            //                var selectAssigneeList = $.map(leadManage.leadAssignToList, function (value, index) {
            //                    if (value.code == leadManage.leadData.assignedToUserCode) {
            //                        return value;
            //                    }
            //                });
            //                leadManage.selectedLeadAssignToList = (selectAssigneeList.length == 0) ? [] : selectAssigneeList[0];
            //            }
        },
        resetMobileEmailFields: function() {
            $("#lead-email-mobile-err").html("");
        },
        createLead: function(e) {
            var leadCreateLoader = Ladda.create(
                document.querySelector(".leadBtnCreateLoader")
            );
            this.errorMessage = "";
            var emailValue = $("#leadEmail").val();
            var mobileValue = $("#leadMobile").val();
            var isValid = validate.formIsValid("leadForm", true);

            if (!$("#leadMobile").valid()) {
                $("#lead-email-mobile-err").html();
                $("#lead-email-mobile-err").html($("#leadMobile-error").html());
                $("#leadMobile-error").html("");
            } else if (!$("#leadEmail").valid()) {
                $("#lead-email-mobile-err").html();
                $("#lead-email-mobile-err").html($("#leadEmail-error").html());
                $("#leadEmail-error").html("");
            } else {
                $("#lead-email-mobile-err").html("");
            }
            var customValidateElements = $("#addLead div.multiselect").map(
                function(i, element) {
                    if ($(element).data("optional") === undefined) {
                        return $(element)
                            .find("input")
                            .attr("id");
                    }
                }
            );
            console.log(customValidateElements);
            var otherCustomValidElements = $("#addLead div.multiselect").map(
                function(i, element) {
                    var elemId = $(element)
                        .attr("id")
                        .replace("-multiselect", "");
                    if ($(element).data("optional") === undefined) {
                        if (customValidateElements.length > 0) {
                            if (
                                $.inArray(elemId, customValidateElements) == -1
                            ) {
                                return elemId;
                            }
                        } else {
                            return elemId;
                        }
                    }
                }
            );
            var customValidate =
                validate.customValidateMultiSelect(customValidateElements) &&
                validate.customValidateMultiSelect(otherCustomValidElements);
            if (
                !(isValid && customValidate && this.leadVerificationError == "")
            ) {
                return false;
            }
            this.leadData.callingCode = this.country.callingCode;
            var formData = this.leadData;
            leadCreateLoader.start();
            this.$Progress.start();
            this.$http.post("/lead/save", formData).then(
                (response) => {
                    if (response.body.hasError) {
                        this.errorMessage = "Something went wrong";
                        //toastr["error"]("Something went wrong!", "FAILED!");
                        toastr["error"](response.body.message);
                        leadCreateLoader.stop();
                        leadCreateLoader.remove();
                        return false;
                    }
                    var result = response.body.result;
                    this.leadData = {};
                    this.$Progress.finish();
                    this.errorMessage = "";
                    leadCreateLoader.stop();
                    leadCreateLoader.remove();
                    $("#addLead").modal("hide");
                    toastr["success"](response.body.message);
                    if (result.code !== undefined) {
                        window.location.href = "/lead/" + result.code;
                    } else if (typeof appLeadList !== "undefined") {
                        appLeadList.getVueItems(1);
                    } else {
                        window.location.href = "/leads";
                    }
                },
                (response) => {
                    //                this.formErrors = response.data;
                    leadCreateLoader.stop();
                    leadCreateLoader.remove();
                    this.errorMessage = "Something went wrong!";
                    toastr["error"]("Something went wrong!", "Failed");
                }
            );
        },
        updateLead: function() {
            var leadUpdateLoader = Ladda.create(
                document.querySelector(".leadBtnUpdateLoader")
            );
            this.errorMessage = "";
            var isValid = validate.formIsValid("leadForm");
            var customValidateElements = $("#addLead div.multiselect")
                .find("input")
                .map(function(i, element) {
                    if ($(element).data("optional") === undefined) {
                        return $(element).attr("id");
                    }
                });
            var otherCustomValidElements = $("#addLead div.multiselect").map(
                function(i, element) {
                    var elemId = $(element)
                        .attr("id")
                        .replace("-multiselect", "");
                    if ($(element).data("optional") === undefined) {
                        if (customValidateElements.length > 0) {
                            if (
                                $.inArray(elemId, customValidateElements) == -1
                            ) {
                                return elemId;
                            }
                        } else {
                            return elemId;
                        }
                    }
                }
            );

            var customValidate =
                validate.customValidateMultiSelect(customValidateElements) &&
                validate.customValidateMultiSelect(otherCustomValidElements);
            if (
                !(isValid && customValidate && this.leadVerificationError == "")
            ) {
                return false;
            }
            var formData = this.leadData;
            leadUpdateLoader.start();
            this.$http
                .post(
                    "/lead/update/generalinfo/" + this.leadData.leadCode,
                    formData
                )
                .then(
                    (response) => {
                        if (response.body.hasError) {
                            this.errorMessage = "Something went wrong";
                            //toastr["error"]("Something went wrong!", "FAILED!");
                            toastr["error"](response.body.message);
                            leadUpdateLoader.stop();
                            leadUpdateLoader.remove();
                            return false;
                        }
                        this.leadData = {};
                        this.errorMessage = "";
                        $("#addLead").modal("hide");
                        toastr["success"](response.body.message);
                        if (typeof appLeadList !== "undefined") {
                            appLeadList.getVueItems(1);
                        }
                        if ($("#clkLeadDetails").length) {
                            $("#clkLeadDetails").trigger("click");
                        }
                        leadUpdateLoader.stop();
                        leadUpdateLoader.remove();
                    },
                    (response) => {
                        leadUpdateLoader.stop();
                        leadUpdateLoader.remove();
                        this.errorMessage = "Something went wrong!";
                        toastr["error"]("Something went wrong!", "Failed");
                    }
                );
        },
    },
});

window.topActionBtnApp = new Vue({
    el: "#topActionBtn",
    methods: {
        openAddLead: function() {
            leadManage.leadData = {
                name: "",
                email: "",
                mobile: "",
                trialAt: "",
                interestedFitnessOption: [],
                fitnessGoal: [],
            };
            leadManage.headerMessage = "Add Lead";
            leadManage.leadVerificationError = "";
            leadManage.openLeadForm("add");
            leadManage.readOnlyEmail = false;
        },
    },
});

Vue.mixin({
    methods: {
        deleteLead: function() {
            var deleteLeadLoader = Ladda.create(
                document.querySelector(".deleteLeadBtnLoader")
            );
            var leadCode = $("#removeItemConfirmModal").data("leadCode");
            var url = "/lead/delete/" + leadCode;
            deleteLeadLoader.start();
            this.$http.post(url).then(
                (response) => {
                    if (response.data.hasError) {
                        toastr["error"](response.body.message);
                        deleteLeadLoader.stop();
                        deleteLeadLoader.remove();
                        return false;
                    }
                    toastr["success"](response.body.message);
                    $("#removeItemConfirmModal").modal("hide");
                    deleteLeadLoader.stop();
                    deleteLeadLoader.remove();
                    if (typeof appLeadList !== "undefined") {
                        appLeadList.getVueItems(1);
                    } else {
                        window.location.href = "/leads";
                    }
                },
                (response) => {
                    toastr["error"]("Something went wrong!", "Failed");
                    deleteLeadLoader.stop();
                    deleteLeadLoader.remove();
                }
            );
        },
        deleteLeadShow: function(leadCode, disable) {
            $("#removeItemConfirmModal .ConfMsg").addClass("hidden");
            if (disable) {
                $("#removeItemConfirmModal")
                    .find("#disableLead")
                    .removeClass("hidden");
            } else {
                $("#removeItemConfirmModal")
                    .find("#enableLead")
                    .removeClass("hidden");
            }
            $("#removeItemConfirmModal")
                .data("leadCode", leadCode)
                .data("disable", disable)
                .modal("show");
        },
        editLead: function(lead) {
            $("form label.error").hide();
            leadUpdateModel.leadData = lead;
            leadUpdateModel.leadData.dob =
                lead.leadUserDob === null || lead.leadUserDob === ""
                    ? ""
                    : Vue.options.filters.convertToDateFormat(lead.leadUserDob);
            leadUpdateModel.leadVerificationError = "";

            if (lead.leadUserEmail !== null) {
                $("#editleadEmail").attr("readonly", true);
            }
            if (lead.leadUserMobile !== "") {
                $("#editleadMobile").attr("readonly", true);
                leadUpdateModel.disableCallingCode = true;
                leadUpdateModel.country.callingCode = lead.callingCode;
                leadUpdateModel.leadData.callingCode = lead.callingCode;
            }
            //single selection
            if (lead.leadUserGender !== null) {
                var genderTypeArr = $.map(
                    leadUpdateModel.genderTypeListArr,
                    function(value, index) {
                        if (
                            value.name.toLowerCase() ==
                            lead.leadUserGender.toLowerCase()
                        ) {
                            return value;
                        }
                    }
                );
                leadUpdateModel.selectedGenderType =
                    genderTypeArr.length == 0 ? [] : genderTypeArr[0];
                leadUpdateModel.leadData.gender =
                    leadUpdateModel.selectedGenderType.id;
            }

            //multiple selection
            var avaliableFitnessOptions = $.map(
                lead.lead_fitness_activities,
                function(value, index) {
                    return value.code;
                }
            );
            leadUpdateModel.leadData.interestedFitnessOption = avaliableFitnessOptions;

            var avaliableFitnessGoal = $.map(lead.lead_fitness_goals, function(
                value,
                index
            ) {
                return value.code;
            });
            leadUpdateModel.leadData.fitnessGoal = avaliableFitnessGoal;

            leadUpdateModel.headerMessage = "Update Lead";
            leadUpdateModel.openLeadGeneralInfoForm("update");
        },
        editLeadGeneralInfo: function(lead) {
            $("form label.error").hide();
            leadProfile.leadData = lead;
            leadProfile.leadVerificationError = "";
            //            leadProfile.leadData = jQuery.extend(true, {}, lead);

            if (lead.leadUserEmail !== null) {
                $("#editleadEmail").attr("readonly", true);
            }
            if (lead.leadUserMobile !== "") {
                $("#editleadMobile").attr("readonly", true);
                leadProfile.disableCallingCode = true;
                leadProfile.country.callingCode = lead.callingCode;
                leadProfile.leadData.callingCode = lead.callingCode;
            }
            leadProfile.leadData.dob =
                lead.leadUserDob === null || lead.leadUserDob === ""
                    ? ""
                    : Vue.options.filters.convertToDateFormat(lead.leadUserDob);

            //            leadProfile.leadData.email = lead.leadUserEmail;
            //            leadProfile.readOnlyEmail = (leadProfile.leadData.email) ? true : false;
            //            leadProfile.leadData.mobile = lead.leadUserMobile;
            //            leadProfile.leadData.code = lead.leadCode;
            //            console.log(leadProfile.leadData);
            //single selection
            if (lead.leadUserGender !== null) {
                var genderTypeArr = $.map(
                    leadProfile.genderTypeListArr,
                    function(value, index) {
                        if (
                            value.name.toLowerCase() ==
                            lead.leadUserGender.toLowerCase()
                        ) {
                            return value;
                        }
                    }
                );
                leadProfile.selectedGenderType =
                    genderTypeArr.length == 0 ? [] : genderTypeArr[0];
                leadProfile.leadData.gender = leadProfile.selectedGenderType.id;
            }
            //            leadProfile.leadData.leadSource = (lead.lead_source !== undefined) ? lead.lead_source.id : '';

            //multiple selection
            var avaliableFitnessOptions = $.map(
                lead.lead_fitness_activities,
                function(value, index) {
                    return value.code;
                }
            );
            leadProfile.leadData.interestedFitnessOption = avaliableFitnessOptions;

            var avaliableFitnessGoal = $.map(lead.lead_fitness_goals, function(
                value,
                index
            ) {
                return value.code;
            });
            leadProfile.leadData.fitnessGoal = avaliableFitnessGoal;

            leadProfile.headerMessage = "Update Lead";
            leadProfile.openLeadGeneralInfoForm("update");
        },
        openInternalDetailsForm: function(lead) {
            $("form label.error").hide();
            leadInternalProfile.leadVerificationError = "";
            leadInternalProfile.leadData = jQuery.extend(true, {}, lead);
            //            leadInternalProfile.leadData.assignToObj = lead.assigned_to_user;
            //            leadInternalProfile.leadData.assignTo = (lead.assigned_to_user !== undefined) ? lead.assigned_to_user.id : '';
            leadInternalProfile.leadData = lead;
            leadInternalProfile.headerMessage = "Update Lead";
            leadInternalProfile.openLeadInternalDetailsForm("update");
        },
    },
});
window.leadGenerator = new Vue({
    el: "#leadGenerator",
    data: {
        errorMessage: "",
        leadInvitationData: { email: "", mobile: "" },
    },
    methods: {
        sendInvitationLink: function() {
            var sendInvitationLoader = Ladda.create(
                document.querySelector(".sendInvitationBtnLoader")
            );
            this.errorMessage = "";
            var isValid = validate.formIsValid("leadInvitationForm", true);
            if (!isValid) {
                return false;
            }
            var formData = this.leadInvitationData;
            //console.log(JSON.stringify(formData));
            sendInvitationLoader.start();
            this.$http.post("/lead/invitation/send", formData).then(
                (response) => {
                    if (response.body.hasError) {
                        this.errorMessage = "Something went wrong";
                        toastr["error"]("Something went wrong!", "FAILED!");
                        sendInvitationLoader.stop();
                        sendInvitationLoader.remove();
                        return false;
                    }
                    this.leadInvitationData = {};
                    this.errorMessage = "";
                    $("#leadGenerator").modal("hide");
                    toastr["success"](response.body.message);
                    sendInvitationLoader.stop();
                    sendInvitationLoader.remove();
                },
                (response) => {
                    //                this.formErrors = response.data;
                    sendInvitationLoader.stop();
                    sendInvitationLoader.remove();
                    this.errorMessage = "Something went wrong!";
                    toastr["error"]("Something went wrong!", "Failed");
                }
            );
            return false;
        },
    },
});
